import React, { useState } from 'react';
import { BookOpen } from 'lucide-react';

export const CourseCover = ({ src, className = '', iconClassName = 'w-8 h-8' }) => {
    const [failed, setFailed] = useState(false);
    if (!src || failed) {
        return (
            <div className="absolute inset-0 flex items-center justify-center bg-primary/10" data-testid="course-cover-fallback">
                <BookOpen className={`${iconClassName} text-primary/30`} />
            </div>
        );
    }
    return <img src={src} alt="" loading="lazy" onError={() => setFailed(true)} className={className} />;
};

export default CourseCover;
